import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import { DialogTitle } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { RAIN_ACCUMULATION } from 'js/constants/WeatherConstants';
import SelectFormControl from 'js/components/UI-Elements/SelectFormControl.jsx';
import { useLangFile } from 'js/context/LanguageContext';

const RainInfoSettingsDialog = (props: RainInfoSettingsDialog.propTypes) => {
  const LangFile = useLangFile();

  return (
    <Dialog maxWidth={'xs'} fullWidth={true} open={props.shown} onClose={props.onClose}>
      <DialogTitle>{LangFile.RainInfoSettingsDialog.title}</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            pb: 2,
          }}
        >
          <SelectFormControl
            title={LangFile.RainInfoSettingsDialog.accumulation}
            label={LangFile.RainInfoSettingsDialog.accumulationLabel}
            disablePadding={true}
            value={props.accumulation}
            onChange={props.onChangeAccumulation}
            options={[
              {
                value: RAIN_ACCUMULATION.LAST_24_HOURS,
                label: LangFile.RainInfoSettingsDialog.accumulationContinuously,
              },
              {
                value: RAIN_ACCUMULATION.SINCE_MIDNIGHT,
                label: LangFile.RainInfoSettingsDialog.accumulationDaily,
              },
            ]}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant={'contained'} onClick={props.onClose}>
          {LangFile.RainInfoSettingsDialog.ok}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

RainInfoSettingsDialog.propTypes = {
  shown: PropTypes.bool,
  onClose: PropTypes.func,
  accumulation: PropTypes.string,
  onChangeAccumulation: PropTypes.func,
};

export default memo(RainInfoSettingsDialog);
